import { CheckboxProps as MUICheckboxProps } from '@mui/material'
import { faSquare, faSquareCheck } from '@fortawesome/free-solid-svg-icons'
import { faSquare as faSquareBorder } from '@fortawesome/free-regular-svg-icons'
import { StyledCheckbox } from './styles'
import { IFieldStatus } from 'main/interfaces'
import { Icon } from '../Icon'
import { Box } from '../box'

interface CheckboxProps extends MUICheckboxProps, IFieldStatus {}

export function Checkbox({ blocked, disabled, ...props }: CheckboxProps) {
  return (
    <StyledCheckbox
      disableRipple={true}
      disabled={disabled || blocked}
      icon={
        <Box
          sx={{
            position: 'relative',
            height: '22px',
            width: '22px',
            '& svg': {
              position: 'absolute',
              top: '3px',
              left: '50%',
              transform: 'translate(-50%)',
            },
          }}
        >
          <Icon icon={faSquare} sx={{ color: 'white', stroke: 'red' }} />
          <Icon icon={faSquareBorder} sx={{ zIndex: 2 }} />
        </Box>
      }
      checkedIcon={<Icon icon={faSquareCheck} />}
      {...props}
    />
  )
}
